// extracted by mini-css-extract-plugin
export default {"invisibleContainer":"mobile-menu-modal_invisibleContainer__mwgu1","visibleContainer":"mobile-menu-modal_visibleContainer__J7oEo","menuIcon":"mobile-menu-modal_menuIcon__KCNFA"};